import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { possibleDateFormats } from 'app-models';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import * as i1 from '@angular/common/http';

class AppServicesLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.childLoadedSubject = new Subject();
        this.childLoaded$ = this.childLoadedSubject.asObservable();
    }
    getTask(type, taskId) {
        return this.httpClient.get(`/${type}/task/${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    formToBeDisabled(stepStatusCode) {
        const isCaseRequest = sessionStorage.getItem('beneQuestIsCaseRequest') === 'true';
        return isCaseRequest ? false : ['NEW', 'COMPLETE', 'SUBMIT'].includes(stepStatusCode);
    }
    fieldToBeDisabled(stepStatusCode) {
        const userType = sessionStorage.getItem('userTypeRole');
        const isCaseRequest = sessionStorage.getItem('beneQuestIsCaseRequest') === 'true';
        if (isCaseRequest) {
            return false;
        }
        if (userType === 'Petitioner' || userType === 'Attorney') {
            return ['NEW', 'COMPLETE'].includes(stepStatusCode);
        }
        if (userType === 'Beneficiary') {
            return ['NEW', 'COMPLETE', 'SUBMIT'].includes(stepStatusCode);
        }
        return false;
    }
    uuid() {
        const val1 = Date.now().toString(36);
        const val2 = Math.random().toString(36).substring(2);
        return val1 + val2;
    }
    parseToDate(dateString) {
        if (!dateString)
            return null;
        const parsedDate = moment(dateString, possibleDateFormats, true);
        return parsedDate.isValid() ? parsedDate.toDate() : null;
    }
    parseToISOString(dateString) {
        if (!dateString)
            return null;
        const parsedDate = moment(dateString, possibleDateFormats, true);
        return parsedDate.isValid() ? parsedDate.toISOString() : null;
    }
    reportLoaded() {
        this.childLoadedSubject.next();
    }
}
AppServicesLibraryService.ɵfac = function AppServicesLibraryService_Factory(t) { return new (t || AppServicesLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
AppServicesLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: AppServicesLibraryService, factory: AppServicesLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppServicesLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class SessionRelatedServiceService {
    constructor() { }
    clearSessionStorage() {
        const keysToKeep = ['transletedLabel'];
        const valuesToKeep = {};
        keysToKeep.forEach(key => {
            const value = sessionStorage.getItem(key);
            if (value !== null) {
                valuesToKeep[key] = value;
            }
        });
        sessionStorage.clear();
        Object.entries(valuesToKeep).forEach(([key, value]) => {
            sessionStorage.setItem(key, value);
        });
    }
}
SessionRelatedServiceService.ɵfac = function SessionRelatedServiceService_Factory(t) { return new (t || SessionRelatedServiceService)(); };
SessionRelatedServiceService.ɵprov = i0.ɵɵdefineInjectable({ token: SessionRelatedServiceService, factory: SessionRelatedServiceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SessionRelatedServiceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/*
 * Public API Surface of app-services-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppServicesLibraryService, SessionRelatedServiceService };
//# sourceMappingURL=app-services-library.js.map
